export const LOAD_MORE_DISCOUNTS_TEXT = 'Load More'
